import { TextField, Grid, MenuItem, Typography } from "@mui/material";
import { useFormContext, Controller } from "react-hook-form";

export default function EinweisungForm() {
  const { control } = useFormContext();
  const verpflichtungsoptionen = ["explizit", "durch Unterzeichnung eines Protokolls"];
  const intervalloptionen = ["jährlich", "halbjährlich", "bei Bedarf"];

  return (
    <Grid container spacing={3} direction="column">
      {/* Beschreibung */}
      <Grid item xs={12}>
      <Typography variant="h4" sx={{ fontWeight: 600, mb: 3 }}>
      Mitarbeiterschulung und Verpflichtung zur Belegablage
              </Typography>
        <Typography variant="body1" gutterBottom>
          Auf dieser Seite dokumentieren Sie die Organisation der Einweisung und Schulung Ihrer Mitarbeiter
          im Zusammenhang mit der Belegablage. Ziel ist es, sicherzustellen, dass alle beteiligten Mitarbeiter
          regelmäßig geschult werden und sich zur Einhaltung der Verfahrensdokumentation verpflichten.
         
        </Typography>
      </Grid>

      {/* Unterweisungsintervall */}
      <Grid item xs={12}>
        <Typography variant="subtitle2" gutterBottom>
        Geben Sie an, in welchem Turnus die Unterweisung der Mitarbeiter erfolgt. Typischerweise jährlich, halbjährlich oder nur bei Bedarf.        </Typography>
        <Controller
          name="unterweisungsintervall"
          control={control}
          render={({ field }) => (
            <TextField {...field} label="Unterweisungsintervall" select fullWidth>
              {intervalloptionen.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>
          )}
        />
      </Grid>

      {/* Verpflichtung zur Einhaltung */}
      <Grid item xs={12}>
        <Typography variant="subtitle2" gutterBottom>
        Wählen Sie aus, wie die Mitarbeiter die Verpflichtung zur Einhaltung der Verfahrensdokumentation bestätigen: explizit (z. B. mündlich) oder durch Unterzeichnung eines Protokolls.
        </Typography>
        <Controller
          name="unterzeichnungsart"
          control={control}
          render={({ field }) => (
            <TextField {...field} label="Verpflichtung zur Einhaltung" select fullWidth>
              {verpflichtungsoptionen.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>
          )}
        />
      </Grid>

      {/* Schulung durch */}
      <Grid item xs={12}>
        <Typography variant="subtitle2" gutterBottom>
        Tragen Sie ein, wer die Schulung durchführt, z. B. die zuständige Führungskraft oder eine andere verantwortliche Person.
        </Typography>
        <Controller
          name="schulungsverantwortlich"
          control={control}
          render={({ field }) => (
            <TextField {...field} label="Schulung durch (z. B. zuständige Führungskraft)" fullWidth />
          )}
        />
      </Grid>
    </Grid>
  );
}
